/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface TaskCounts {
  pending?: number;
  done?: number;
  archived?: number;
  unread_for_user?: number;
}
